package org.multiplatform.kotfolio.util

object Constants {
    const val VERSION = "2.0.2"

    //Social Link
    const val FACEBOOK_LINK = ""
    const val GITHUB_LINK = "http://github.com/fluttertutorialin"
    const val GOOGLE_DEVELOPER_LINK = ""
    const val LINKEDIN_LINK = "https://www.linkedin.com/in/multiplatformdeveloper/"

    //Font
    const val SECTION_WIDTH = 2560 // Increased from 1920 to support wider screens
    const val FONT_FAMILY = "sans-serif"
    val AMBER_500 = com.varabyte.kobweb.compose.ui.graphics.Color.rgb(245, 158, 11)

    //PROJECT URL
    const val PROJECT_CUSTOMER_SERVICE_URL = "https://github.com/fluttertutorialin/customer_service"
    const val PROJECT_FOOD_CAFE_URL = "https://github.com/fluttertutorialin/foodcafe"
    const val PROJECT_MVP_EVENT_STAFFING_URL = "https://github.com/fluttertutorialin/mvpeventstaffing"
    const val PROJECT_MIKAN_DELIVERY_URL = "https://github.com/fluttertutorialin/mikan_delivery"
    const val PROJECT_SERVICE_PROVIDER_URL = "https://github.com/fluttertutorialin/service_provider"

    const val PROJECT_MOSEC_URL = "https://vendormosec.netlify.app" // /mosec netify

    //BLOG URL
    const val COMMON_WRAPPER_URL = "/compose/common_wrapper"
    const val ROOM_DATABASE_URL = "/compose/room"

    //KOBWEB
    const val KOBWEB_API_URL = "/kobweb_api"

    //WASM
    const val BASIC_WASM_URL = "/wasm_basic"

    //KOTLIN REACT
    const val BASIC_KOTLIN_REACT_URL = "/kotlin_react_basic"
    const val ROUTER_KOTLIN_REACT_URL = "/kotlin_react_router"
    const val REDUX_KOTLIN_REACT_URL = "/kotlin_react_redux"

    //ANDROID STUDIO
    const val GRADLE_URL = "/androidstudio/gradle"

    //JAVA
    const val JAVA_THREAD_URL = "/java/thread"
    const val JAVA_ABSTRACT_CLASS_URL = "/java/abstract_class"
    const val JAVA_INHERITANCE_URL = "/java/inheritance"

    //DI
    const val HILT_DI_URL = "/di_hilt"

    const val KOIN_BASIC_URL = "/koin/basic"

    const val KOIN_URL = "/koin/koin"

    const val KOIN_ANNOTATIONS_URL = "/koin/annotations"

    const val KOIN_NAVIGATION_URL = "/koin/navigation"

    const val METRO_URL = "/metro"

    //API CALLING
    const val KTOR_URL = "/ktor"
    const val KTOR_FIT_URL = "/ktorfit"
    const val KTOR_SOCKET_URL = "/socket_ktor"
    const val RPC_URL = "/api_calling_rpc"

    const val CLEAN_ARCHITECTURE_COMPOSE_URL = "/compose/clean_architecture"
    const val CLEAN_ARCHITECTURE_COMPOSE_MVI_URL = "/compose/mvi"

    const val KOTEST_URL = "/kotest"

    const val INTERVIEW_QUESTION_COMPOSE_URL = "/compose/questions"

    //KMP
    const val ROOM_KMP_URL = "/kmm/room"

    //MOSEC APPLICATION
    const val MOSEC_INTRO_1 = "MoSeC is a multivendor Hybrid Platform Flutter material 3.41.7 designed and Dart 3.11.5, rending the application using impreller for its multitude of vendors to list old mobile and sell their inventory hassle-free. The App experience is as simple as Ready, Set & Go."
    const val MOSEC_INTRO_2 = "The application will unify the numerous vendors in one common marketplace where they will be able to manage their sales, reconcile payments, promote their listings, check what is trending, etc."
    const val MOSEC_INTRO_3 = "The MoSeC (Mobex Seller Central) APP is open to all sellers across locations of Ahmedabad, Surat, Delhi, and Bangalore. MoSeC app uses 2000+ vendors"

    val MAIN_INTRO =
        listOf(
            "Building AI-powered mobile products that ship fast and scale"
        )

    val BIO_PARAGRAPHS = listOf(
        "Multiplatform developer is a versatile Software Developer proficient in Android, Jetpack Compose, KMM, KMP, kobWeb, Flutter, iOS, SwiftUI, PHP, .net, Web design, Wordpress and Gaming development.",
        "Additionally, I demonstrates a hands-on approach to crafting elegant User Interfaces, showcasing a talent for bug resolution and consistently delivering optimal results."
    )

    const val ROLE = "SoftWare Developer | Seller Management Portal, Refurbished Electric (Amazon, Flipkart) | Wooden Door Business"
}

object Kotlin {
    //KOTLIN
    const val DESIGN_PATTERNS_URL = "/kotlin/design_pattern/design_patterns"
    const val QUESTIONS_URL = "/kotlin/questions"

    const val HIGHER_ORDER_FUNCTIONS_URL = "/kotlin/higher_order_functions"

    const val FILTER_COLLECTION_URL = "/kotlin/filter_collection"
    const val MUTEX_URL = "/kotlin/mutex"
    const val NOTE_BOOK_URL = "/kotlin_notebook"

    object KotlinNewFeature {
        const val NEW_FEATURE_URL = "/kotlin/new_feature/2.0"
        const val NEW_FEATURE_2_0_20_URL = "/kotlin/new_feature/2.0.20"
        const val NEW_FEATURE_2_1_0_URL = "/kotlin/new_feature/2.1.0"
        const val NEW_FEATURE_2_2_0_URL = "/kotlin/new_feature/2.2.0"
        const val NEW_FEATURE_2_3_0_URL = "/kotlin/new_feature/2.3.0"
        const val NEW_FEATURE_2_3_20_URL = "/kotlin/new_feature/2.3.20"
        const val NEW_FEATURE_2_4_0_URL = "/kotlin/new_feature/2.4.0"

        const val NEW_FEATURE_2_5_0_BETA_1_URL = "/kotlin/new_feature/2.5.0.beta1"
    }
}

object Coroutines
{
    const val BASIC_URL = "/coroutines/basic"
    const val CREATE_URL = "/coroutines/create"
    const val DISPATCHERS_URL = "/coroutines/dispatchers"
    const val STATE_SHARED_FLOW_URL = "/coroutines/state_shared_flow"
    const val CONTEXT_CANCELLATION_URL = "/coroutines/context_cancellation"
    const val CONVERT_FLOW_URL = "/coroutines/convert_flow"
    const val FLOW_BASIC_URL = "/coroutines/flow_basic"

    const val FLOW_CREATE_URL = "/coroutines/flow_create"
    const val FLOW_BUILDERS_URL = "/coroutines/flow_builders"
    const val FLOW_ON_URL = "/coroutines/flow_on"
    const val FLOW_COMBINE_URL = "/coroutines/flow_combine"

    const val SUSPEND_URL = "/coroutines/suspend"
    const val FILTER_URL = "/coroutines/filter"
    const val CHANNEL_URL = "/coroutines/channel"

    const val QUESTIONS_URL = "/coroutines/questions"

    const val SEMAPHORE_URL = "/coroutines/semaphore"

    const val SINGLE_QUESTIONS_URL = "/coroutines/single_questions"
}

object JetpackCompose {
    object SideEffect {
        const val APP_STATE_TRANSFORM_URL = "/compose/side_effect/appstatetransform"
        const val SIDE_EFFECT_EXTERNAL_URL = "/compose/side_effect/side_effect"
        const val REMEMBER_URL = "/compose/side_effect/remember"

        const val REMEMBER_SAVEABLE_URL = "/compose/side_effect/remember_saveable"

        const val REMEMBER_SERIALIZABLE_URL = "/compose/side_effect/remember_serializable"

        const val REMEMBER_UPDATED_STATE_URL = "/compose/side_effect/remember_updated_state"
        const val REMEMBER_COROUTINE_SCOPE_URL = "/compose/side_effect/remember_coroutine_scope"
        const val DERIVED_STATE_OF_URL = "/compose/side_effect/derivedstateof"
        const val PRODUCE_STATE_URL = "/compose/side_effect/produce_state"
        const val LAUNCHED_EFFECT_URL = "/compose/side_effect/launched_effect"
        const val SNAPSHOT_FLOW_URL = "/compose/side_effect/snapshot_flow"

        const val SAVEABLE_STATE_HOLDER_URL = "/compose/side_effect/saveable_state_holder"

        const val SAVER_CUSTOM_URL = "/compose/side_effect/saver_custom"

        const val RETAIN_URL = "/compose/side_effect/retain"

        const val DISPOSABLE_EFFECT_URL = "/compose/side_effect/disposable_effect"

        const val SAVED_STATE_URL = "/compose/side_effect/savedstate"

        const val REMEMBER_OBSERVER_URL = "/compose/side_effect/remember_observer"

        const val SIDE_EFFECT_URL = "/compose/side_effect"
        const val STABILITY_URL = "/compose/side_effect/stability"
    }

    const val BASIC_URL = "/compose/basic"
    const val MODIFIER_URL = "/compose/modifier"
    const val LIFE_CYCLE_URL = "/compose/internal/lifecycle"
    const val INTERNAL_RENDER_PROCESS_URL = "/compose/internal/render_process"

    const val RUNTIME_URL = "/compose/internal/runtime"

    const val UDF_URL = "/compose/udf"
    const val STATE_HOSTING_URL = "/compose/state_hosting"
    const val COMPOSITIONAL_LOCALS_URL = "/compose/compositional_locals"

    const val VIEWMODEL_URL = "/compose/viewmodel/viewmodel"

    const val VIEWMODEL_AUTO_CLOSEABLE_URL = "/compose/viewmodel/autocloseable"

    const val NAVIGATION_URL = "/compose/navigation"

    const val SCOPED_SLOTS_URL = "/compose/scoped_slots"

    const val PAGINATION_URL = "/compose/pagination"

    const val ANIMATION_URL = "/compose/animation"

    const val STATE_MANAGE_URL = "/compose/state_manage"
    const val PREF_STORE_URL = "/compose/pref_store"
    const val COMPOSITION_ARCHITECTURE_URL = "/compose/architecture/composition"

    //COMPOSE CODING
    const val MULTI_MODULE_URL = "/compose/multi_module"
}

object KMM {
    //KMM
    const val BASIC_URL = "/kmm/basic"
    const val BASIC_PROGRAMMING = "/kmm/basic_component"

    const val NS_USER_DEFAULTS_URL = "/kmm/ns_user_defaults"

    object KMP {
        const val CONSTRAINT_LOGIN_URL = "/constraintlogin"

        const val PLUGIN_URL = "/kmm/plugin"

        const val SHARED_VIEWMODEL_URL = "/shared/viewmodel"

        const val SECURE_STORAGE_URL = "/kmm/secure_storage"

        const val REALM_URL = "/kmm/realm"
        const val FIREBASE_URL = "/kmm/firebase"

        const val FORMZ_VALIDATION_URL = "/kmm/formz_validation"

        const val SANDWICH_URL = "/kmm/sandwich"

        const val MULTIPLATFORM_SETTINGS_URL = "/kmm/multiplatform_settings"

        const val LOG_URL = "/kmm/log"
    }
}

object Flutter {
    const val WIDGET_ARCHITECTURE_URL = "/flutter/basic"
    const val WIDGET_LIFECYCLE_URL = "/flutter/widget_lifecycle"
    const val CLEAN_ARCHITECTURE_URL = "/flutter/clean_architecture"
    const val SOLID_PRINCIPLES_URL = "/flutter/solid_principles"
    const val ASYNCHRONOUS_URL = "/flutter/asynchronous"
    const val ISOLATE_URL = "/flutter/isolate"
    const val FREEZED_URL = "/flutter/freezed"
    const val BLOC_URL = "/flutter/bloc"
    const val GETX_URL = "/flutter/getx"
    const val GET_IT_DI_URL = "/flutter/get_it"
    const val NULL_SAFETY_DART_URL = "/flutter/null_safety"
    const val FIRE_BASE_URL = "/flutter/firebase"
    const val PLUGIN_URL = "/flutter/plugin"
    const val INTERVIEW_QUESTIONS_URL = "/flutter/questions"
}

object Kids {
    object Grade3 {
        object EVS {
            const val HUMAN_BODY_URL = "/kids/grade_3/human_body"
        }
    }

    object Maths {
        const val BASIC_MATH_URL = "/kids/maths/basic"
        const val PLACE_FACE_VALUE_URL = "/kids/maths/place_face_value"
        const val ORDINAL_NUMBER_URL = "/kids/maths/ordinal_number"
    }
    object EVS {
        const val BODY_URL = "/kids/body"
        const val WATER_URL = "/kids/water"
        const val AIR_URL = "/kids/air"
        const val STORIES_URL = "/kids/stories"
        const val ANIMALS_URL = "/kids/animals"
        const val INDIAN_FESTIVAL_URL = "/kids/indian_festival"

        const val WEATHER_URL = "/kids/weather"

        const val LIVING_SEASONS_URL = "/kids/living_seasons"

        const val FAMILY_URL = "/kids/family"

        const val SKY_URL = "/kids/sky_above"

        const val EARTH_URL = "/kids/earth"

        const val VISIT_PLACES_URL = "/kids/visit_places"

        const val OUR_HELPER_URL = "/kids/our_helper"

        const val COMMUNICATION_URL = "/kids/communicate"

        const val SHELTER_URL = "/kids/shelter"

        const val OUR_SCHOOL = "/kids/our_school"

        const val USEFUL_PLACES_URL = "/kids/useful_places"

        const val SOLAR_SYSTEM_URL = "/kids/solar_system"

        const val PLANTS_URL = "/kids/plants"

        const val PLANTS_MAKE_FOOD_URL = "/kids/plants_make_food"

        const val AGRICULTURE_INDIA_URL = "/kids/agriculture_india"
        const val RIVER_SYSTEM_URL = "/kids/river_system"
    }

    const val DICTATION_URL = "/kids/dictation/dictation_2"

    object RideToRider {
        object Second {
            const val CAN_READ_URL = "/kids/ride_to_read/class_2/can_read"
            const val WIGGLY_TOOTH_URL = "kids/ride_to_read/class_2/wiggly_tooth"
            const val MASON_URL = "kids/ride_to_read/class_2/mason"

            const val STORY_URL = "kids/ride_to_read/class_2/story"

            const val DOUBLE_TROUBLE_URL = "kids/ride_to_read/class_2/double_trouble"

            const val GOOD_PLAY_URL = "kids/ride_to_read/class_2/good_play"

            const val LITTLE_TURTLE_URL = "kids/ride_to_read/class_2/little_turtle"

            const val MAGIC_PLAYHOUSE_URL = "kids/ride_to_read/class_2/magic_playhouse"

            const val TUCKET_BUCKET_URL = "kids/ride_to_read/class_2/tucket_bucket"
            const val COMPREHENSION_URL = "kids/ride_to_read/class_2/comprehension"

            const val PASSAGE_URL = "kids/exam/grade2/passage"
        }
    }

    object TestPaper {
        const val ENGLISH_1_URL  = "/kids/exam/grade2/english1"
    }
}

object Listing {
    //Flipkart
    const val PICKUP_OPTIMIZATION_URL = "/flipkart_pickup_optimization"

    const val CHOPPING_BOARD_URL = "/listing/chopping_board"

    const val LABEL_CROPPING_URL = "/listing/label_cropping"

    const val KITCHEN_TROLLEY_METAL_URL = "/listing/kitchen_trolley_metal"
    const val WARDROBE_PLASTIC_URL = "/listing/wardrobe_plastic"
    const val STEP_LADDER_URL = "/listing/step_ladder"

    const val CLOTH_DRYER_VERTICAL_URL = "/listing/cloth_dryer"

    const val PANEER_PRESS_MAKER_URL = "/listing/paneer_press_maker"

    const val WALL_MOUNTED_URL = "/listing/wall_mounted"
}

object Res {
    object Image {
        const val MY_IMAGE = "hero_bg.jpg"
        const val AVATAR_1 = "avatar1.png"
        const val AVATAR_2 = "avatar2.png"
        const val AVATAR_3 = "avatar3.png"
        const val AVATAR_4 = "avatar4.png"
        const val AVATAR_5 = "avatar5.png"
        const val AVATAR_6 = "avatar6.png"
    }

    object ProjectImage {

        const val PORTFOLIO_CUSTOMER_SERVICE = "portfolio_flutter_customer_service.png"
        const val PORTFOLIO_SERVICE_PROVIDER = "portfolio_flutter_service_provider.png"
        const val PORTFOLIO_MOSEC = "portfolio_flutter_mosec.png"

        const val PORTFOLIO_FOOD_CAFE = "portfolio_flutter_food_cafe.png"

        const val PORTFOLIO_MVP_EVENT_STAFFING = "portfolio_flutter_mvp_event_staffing.png"

        const val PORTFOLIO_ATTENDANCE = "portfolio_kmm_attendance.png"

        //KMM
        const val PORTFOLIO_SHOPPING_MALL = "portfolio_kmm_shopping_mall.png"

    }

    object Icon {
        const val LINK_ICON = "link_icon.svg"
        const val STAR = "star_icon.svg"

        const val CROSS_PLATFORM_ANDROID = "service_cross_platform_android.svg"
        const val AGILE_CROSS_FUNCTIONAL = "service_agile_cross_functional.svg"
        const val AI_ASSISTED_DEVELOPMENT = "service_ai_assisted_development.svg"
        const val BACKEND_CORE = "service_backend_core.svg"
        const val DEPLOYMENT_INFRASTRUCTURE = "service_deployment_infrastructure.svg"
        const val SECURITY_TESTING = "service_security_testing.svg"

    }
}
